module.exports = __webpack_public_path__ + "img/nav01_h.351be129.png";